import {Component, Input, OnInit} from '@angular/core';
import {UserService} from "../../../../lib/user.service";
import {UserProfileType, userProfileTypes} from "../../../../lib/auth.service";
import {DataTypeObject} from "../../../../util/core-utils";

@Component({
  selector: 'app-user-auth-method-list',
  templateUrl: './user-auth-method-list.component.html',
  styleUrls: ['./user-auth-method-list.component.scss']
})
export class UserAuthMethodListComponent implements OnInit {

  @Input()
  readonly: boolean = false;

  @Input()
  userId: number;

  methods: AuthMethodModel[] = [];
  cannotDisable: boolean = false;

  constructor(private userService: UserService) {
  }

  ngOnInit(): void {

  }

  public initComponent() {
    this.loadMethods();
  }

  private loadMethods() {
    this.userService.loadAuthMethods({id: this.userId}).subscribe(result => {
      this.methods = result.map(r => ({
        authMethod: <UserProfileType>r.auth_method,
        enabled: r.enabled,
        available: r.available,
        userProfileTypeObject: userProfileTypes.find(t => t.id === r.auth_method)
      }));
      this.cannotDisable = this.methods.filter(r => r.enabled).length <= 1;
    })
  }

  setDisabled(method: AuthMethodModel, disabled: boolean) {
    this.userService.setAuthMethodDisabled({id: this.userId, method: method.authMethod, disabled: disabled})
      .subscribe(result => {
        this.loadMethods();
      });
  }

}

interface AuthMethodModel {
  authMethod: UserProfileType;
  enabled: boolean;
  available: boolean;
  userProfileTypeObject?: DataTypeObject<UserProfileType>;
}
